import AnimatedText from './AnimatedText'

export default AnimatedText
